import React from "react";
import { Helmet } from "react-helmet-async";
import { Download } from "lucide-react";

const VIDEOS = [
  { file: "camcpc-ad-english-widescreen-45s", title: "English, widescreen 16:9 (45s)", use: "YouTube ads and the website", size: "11.6 MB" },
  { file: "camcpc-ad-english-vertical-30s", title: "English, phone 9:16 (30s)", use: "YouTube Shorts, Instagram and Facebook Reels", size: "13.5 MB" },
  { file: "camcpc-ad-arabic-widescreen-42s", title: "Arabic, widescreen 16:9 (42s)", use: "YouTube ads for Arabic audiences", size: "10.2 MB" },
  { file: "camcpc-ad-arabic-vertical-30s", title: "Arabic, phone 9:16 (30s)", use: "Shorts and Reels for Arabic audiences", size: "10.3 MB" },
];

const Card = ({ v }) => (
  <div className="bg-white border border-stone-200 rounded-md p-5 flex gap-5 items-center" data-testid={`video-card-${v.file}`}>
    <img src={`/ad-videos/${v.file}.jpg`} alt={`Still from ${v.title}`} className="w-28 h-20 object-cover rounded" />
    <div className="flex-1">
      <h2 className="font-serif text-xl">{v.title}</h2>
      <p className="text-sm text-ink-muted">{v.use}{v.size && ` · ${v.size}`}</p>
    </div>
    <a href={`/ad-videos/${v.file}.mp4`} download={`${v.file}.mp4`} data-testid={`video-download-${v.file}`}
      className="btn-primary inline-flex items-center gap-2 whitespace-nowrap"><Download size={16} /> Download</a>
  </div>
);

export default function VideoDownloads() {
  return (
    <div className="container-ccc py-16 max-w-3xl" data-testid="video-downloads-page">
      <Helmet><title>Video downloads</title><meta name="robots" content="noindex,nofollow" /></Helmet>
      <h1 className="font-serif text-4xl sm:text-5xl">Video downloads</h1>
      <p className="mt-4 text-ink-muted">Each button saves the .mp4 file to your Downloads folder, ready to upload to YouTube.</p>
      <a href="/ad-videos/camcpc-ads-english.zip" download data-testid="video-download-english-zip"
        className="mt-6 inline-flex items-center gap-2 underline text-bronze-dark"><Download size={16} /> Both English videos (zip, 25 MB)</a>
      <div className="mt-8 grid gap-4">{VIDEOS.map((v) => <Card key={v.file} v={v} />)}</div>
    </div>
  );
}
